import PageContainer from '@/views/base/page.vue'
export default [
  {
    path: '/index',
    component: PageContainer,
    children: [
      {
        path: '/story',
        component: () => import('@/views/story/index.vue'),
        meta: { title: '事记', keepAlive: true, needAuth: false }
      },
      {
        path: '/story/detail',
        component: () => import('@/views/story/story-detail.vue'),
        meta: { title: '事记详情', keepAlive: false, needAuth: false }
      },
    ]
  }
]
